import { request } from '@/shared/api/request'

export const contractAdjustmentXml = (data) => {
	return request({ url: 'contract/labor/contractAdjustment/xml', method: 'POST', data })
}

export const contractAdjustment = (payload) => {
	return request({ url: 'contract/labor/contractAdjustment/send', method: 'POST', data: payload })
}
